import VIDABOO_CONSTANTS from '../config/consts';
import {
  WSService,
  ShoutingRoomService,
  ListeningRoomService,
  PrivateRoomService,
} from './websocketService';
import UserService from './restServices/userService';
import {AuthRestService} from './restServices/restServices';
// import ChatService from "./chatService";
import history from '../AppModule/history';
import analyticsService from './analyticsService';
import storageService from './storageService';
import utilsService from './utilsService';
import scheduleUtiles from '../components/scheduleComponents/scheduleUtils';
import postMessageService from './postMessageService';
import navigationService from './navigationService';

// const contScope = {};

export default class AuthenticationServiceBaseClass {
  setContextCurrentUser = null;
  currentUser = {};

  constructor(user, setContextCurrentUser, resetContext) {
    this.currentUser = user;
    this.setContextCurrentUser = setContextCurrentUser;
    this.resetContext = resetContext;

    if (!VIDABOO_CONSTANTS.NATIVE_APP)
      window.addEventListener('storage', this.handleLocalStorageChange, false);
  }
  setCurrentUser(newUser) {
    this.currentUser = newUser;
  }

  login(user, successCallbackFunction, failCallbackFunction) {
    // console.debug("loginnnnnnnnnnnnnn", failCallbackFunction);
    AuthRestService.save(
      {endpoint: 'signin'},
      {email: user.email, password: user.password},
      (resource) => {
        this.loginSuccessFunction(resource, successCallbackFunction);
      }, // success
      (response) => {
        console.debug('error response is', response);
        // console.debug(response.data);
        if (failCallbackFunction) {
          // console.debug("trueeeeeeeeeeeeeeeeeee");
          this.logout();
          failCallbackFunction(response.data);
        }
      }, // failure
    );
  }
  register(user, successCallbackFunction, failCallbackFunction) {
    user.role = 'STANDARD';
    const {
      marketingParameterAvailable,
      marketingParameterDto,
      partnerAffiliateId,
    } = analyticsService.getMarketingParametersForRegistration();
    user.marketingParameterAvailable = marketingParameterAvailable;
    user.marketingParameterDto = marketingParameterDto;
    user.partnerAffiliateId = partnerAffiliateId;
    user.timezone = scheduleUtiles.generateGuessedTimezone();
    // console.debug(user);
    UserService.createUser(
      user,
      (resource) => {
        var newUser = resource.userDto;
        newUser.password = user.password;
        storageService.setItem('token', resource.token);
        // storageService.setItem("email", resource.userDto.email);
        storageService.setItem('uid', resource.userDto.userId);
        //localStorage.removeItem('guestUid');
        // return;
        this.login(newUser, successCallbackFunction, failCallbackFunction);
      }, // success
      (response) => {
        this.logout();
        if (
          failCallbackFunction !== null &&
          failCallbackFunction !== undefined
        ) {
          failCallbackFunction(response.data);
        }
      },
    ); // failure
  }

  logout(callbackFunction) {
    this.resetContext();
    navigationService.resetExpertHomeContextAndRootNav();
    if (this.currentUser) {
      storageService.removeItem('token');
      // localStorage.removeItem("email");
      storageService.removeItem('uid');
      storageService.removeItem(
        VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.LAST_DATA_PERMISSION_REQ_TIME,
      );
      storageService.removeCookieItem(
        VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.CONSOLTO_USER_ID,
      );
      storageService.removeItem(
        VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.SELECTED_MENTOR_IDS,
      );

      if (this.currentUser.guest && this.currentUser.userId !== null) {
        // console.debug('no need to logout guest');
      } else {
        this.createGuestUser((guestUserDto) => {
          storageService.setItem('guestUid', guestUserDto.userId);
          this.establishNewWebsocketConnection(guestUserDto.userId);
          this.setContextCurrentUser(guestUserDto);
        });
      }
    }
    //history.push("/login");
    if (callbackFunction) callbackFunction(); //history.push("/login"); // moving to home page. This will also cause 'requireAuth' and then will create guest and WSSocket
  } //logout

  changePassword(newPassObject, successCallbackFunction, failCallbackFunction) {
    // console.debug("api caleed");
    newPassObject.token = storageService.getItem('token');
    AuthRestService.update(
      {
        endpoint: 'change',
      },
      newPassObject,
      (resource) => {
        // success
        // history.push('/login'); // on success, we'll move to the success page
        successCallbackFunction(resource);
      },
      (response) => {
        console.debug('response data', response.data);
        failCallbackFunction(response.data);
        // console.debug(response.data);
      },
    );
  }
  forgotPassword(email, successCallbackFunction, failCallbackFunction) {
    // console.debug(email);
    AuthRestService.get(
      {
        endpoint: 'forgot',
        endpointParam: email,
      },
      {
        endpoint: 'forgot',
        endpointParam: email,
      },
      (resource, response) => {
        // console.debug(resource);
        successCallbackFunction(response);
      }, // success
      (response) => {
        // console.debug(response.data);
        failCallbackFunction(response.data);
      },
    );
  }
  resetPassword(newPassObject, successCallbackFunction, failCallbackFunction) {
    // console.debug("api caleed");
    AuthRestService.update(
      {
        endpoint: 'reset',
      },
      newPassObject,
      (resource) => {
        // success
        // history.push('/login'); // on success, we'll move to the success page
        successCallbackFunction(resource);
      },
      (response) => {
        console.debug('response data', response.data);
        failCallbackFunction(response.data);
        // console.debug(response.data);
      },
    );
  }

  requireAuth = async () => {
    // in charge of updating currentUser & websocket upon any route change.
    return new Promise((resolve, reject) => {
      let currentUser = this.currentUser;
      try {
        if (window.callInitFldObj !== undefined) {
          // fixing bug when opening callInPopup in Safari,
          // iharel - todo - add back, 22.4.2019 $rootScope.waitForUserPromise.resolve();
          this.currentUser = window.callInitFldObj.currentUser;
          this.setContextCurrentUser(window.callInitFldObj.currentUser);
          currentUser = this.currentUser;

          this.establishNewWebsocketConnection(currentUser.userId);

          resolve();
        } else {
          let token = storageService.getItem('token');
          let userId = storageService.getItem('uid');
          if (token && userId) {
            if (currentUser && Object.keys(currentUser).length === 0) {
              //got token but user details not saved. needs to fetch them from DB.
              // var email = storageService.getItem("email");
              UserService.getUserByUserId(
                userId,
                token,
                (userDto) => {
                  //release waitForUserPromise
                  // iharel - todo - add back, 22.4.2019 $rootScope.waitForUserPromise.resolve();

                  // this.fetchProfilePhoto();

                  this.establishNewWebsocketConnection(userDto.userId);
                  this.setContextCurrentUser(userDto);

                  resolve();

                  // release deferred;
                },
                () => {
                  // couldn't fetch the userData. need to randomize a user as guest.

                  this.createGuestUser((guestUserDto) => {
                    storageService.removeItem('token');
                    storageService.removeItem('uid');
                    storageService.removeCookieItem(
                      VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.CONSOLTO_USER_ID,
                    );

                    storageService.setItem('guestUid', guestUserDto.userId);

                    // iharel - todo - add back, 22.4.2019 $rootScope.waitForUserPromise.resolve();
                    this.establishNewWebsocketConnection(guestUserDto.userId);
                    this.setContextCurrentUser(guestUserDto);

                    resolve();
                  });
                },
              );
            } else {
              // user is logged in and user details are already fetched.
              if (WSService.socketEstablished() === false) {
                //WebSocekt should be already established. if not - create it.
                this.establishNewWebsocketConnection(currentUser.userId);
              } else if (WSService.socketEstablished() === true) {
                this.initWebsocketListeners(currentUser.userId);
              } else if (WSService.socketEstablished() === 'started') {
                //iharel: bug fix 7.2.2020: when user logged in from www.consolto.com, she hit the login page and first requireAuth happened. Then, automatic re-route to dashboard
                // caused another requireAuth, this time with an already-fetched user. So WSService.socketEstablished was on "started" and we shouldn't init the websocket listeners.
                // the first call to requireAuth will handle that. Eventually, prevented this behavior from the authenticationComponents's ComponentDidMount function.
              }
              resolve();

              // iharel - todo - add back, 22.4.2019  $rootScope.waitForUserPromise.resolve();
            }
          } else {
            // couldn't fetch the userData because no token exists. need to randomize a user as guest.

            if (utilsService.getIsEmbeddedExpertHome()) {
              // Embedded SSO
              // embedded and don't have token/userId --> need to ask hosting website.
              postMessageService.doWhenReceiveCreds((credsObj) => {
                const user = {
                  email: credsObj.email,
                  password: credsObj.password,
                };
                this.login(user);
              });
              resolve();
            } else {
              if (
                currentUser !== undefined &&
                currentUser !== null &&
                currentUser.guest === true
              ) {
                // already guest in this session. No need to regenerate
                // console.debug('user already defined');
                if (!WSService.socketEstablished()) {
                  //WebSocekt should be already established. if not - create it.
                  this.establishNewWebsocketConnection(currentUser.userId);
                } else {
                  this.initWebsocketListeners(currentUser.userId);
                }
                resolve();

                // iharel - todo - add back, 22.4.2019 $rootScope.waitForUserPromise.resolve();
              } else {
                // wasn't a guest user. Need to create new guestUserDto
                this.createGuestUser((guestUserDto) => {
                  storageService.setItem('guestUid', guestUserDto.userId);
                  this.establishNewWebsocketConnection(guestUserDto.userId);
                  this.setContextCurrentUser(guestUserDto);

                  resolve();

                  // rootscope fix $rootScope.waitForUserPromise.resolve();
                });
              }
            }
          }
        }
      } catch (e) {
        reject(e.message);
      }
    });
  };

  establishNewWebsocketConnection(userId) {
    ListeningRoomService.clearAllCallbackFunctions();
    ShoutingRoomService.clearAllCallbackFunctions();
    PrivateRoomService.clearAllCallbackFunctions();
    // ShoutingRoomService.clearAllCallbackFunctions();
    WSService.disconnect(); // was guest user, now logged in with real user credentials or the other way around
    WSService.connect({
      userId: userId,
    });
    // when websocket disconnects or when user login/logout, the problem is that the "connected" is fired again and
    // all the below process initiates but in the directives, it doesn't trigger the process of attaching
    // listeners (doWhenMessageReceivedFromShoutingRoom)

    ListeningRoomService.connectToMyListeningRoom(userId); // connecting to own ListeningRoom as subscriber
    ShoutingRoomService.connectToPeerShoutingRoom(userId, userId); // connecting to own ShoutingRoom as subscriber
    ShoutingRoomService.connectToMyShoutingRoom(userId); //as publisher
  }
  buildGuestUserDto(guestUserId) {
    var guestUserDto = {
      guest: true,
      role: 'GUEST',
      firstName: 'guest',
      userId: guestUserId,
    };
    return guestUserDto;
  }
  createGuestUser(successCallbackFunction) {
    var guestUserId = storageService.getItem('guestUid');
    if (guestUserId === null || guestUserId === undefined) {
      //never created guestUserId in the past.
      UserService.createGuestUser(
        (response) => {
          var guestUserDto = this.buildGuestUserDto('guid_' + response.userId);
          successCallbackFunction(guestUserDto);
        },
        () => {
          console.debug('Error 121: could not retrieve guest user Id');
          var randomGuestId =
            new Date().getTime() + Math.floor(Math.random() * 100000000);
          var guestUserDto = this.buildGuestUserDto('guid_' + randomGuestId);
          successCallbackFunction(guestUserDto);
        },
      );
    } else {
      var guestUserDto = this.buildGuestUserDto(guestUserId);
      successCallbackFunction(guestUserDto);
    }
  }
  initWebsocketListeners(/* userId, profileName */) {
    ShoutingRoomService.clearAllCallbackFunctions();
    ListeningRoomService.clearAllCallbackFunctions();
    PrivateRoomService.clearAllCallbackFunctions();
    // iharel - todo - add back, 22.4.2019 $rootScope.waitForWSConnectPromise.resolve();
    // ShoutingRoomService.connectToPeerShoutingRoom(userId, userId, profileName); // connecting to own ShoutingRoom
    //$rootScope.$broadcast('WSConnectedBroadcast', 'true');
  }
  handleLocalStorageChange(event) {
    if (utilsService.getIsClient()) return;
    if (
      (event.key === 'token' && event.storageArea.token === undefined) ||
      (event.key === 'uid' && event.storageArea.uid === undefined)
    )
      history.push('/login');
    else if (
      (event.key === 'token' && event.storageArea.token) ||
      (event.key === 'uid' && event.storageArea.uid)
    ) {
      window.location.reload();
    }
  }
  loginSuccessFunction(resource, successCallbackFunction) {
    // console.debug('current user is: ' + JSON.stringify(resource.userDto));
    //if (VIDABOO_CONSTANTS.TEST_ENV) {debugger};
    storageService.setItem('token', resource.token);
    // storageService.setItem("email", resource.userDto.email);
    storageService.setItem('uid', resource.userDto.userId);
    // storageService.setCookie('uid', resource.userDto.userId, 30); // placed in expertHome instead because we want to refresh expire-time upon every entrance to the backoffice.

    //localStorage.removeItem('guestUid');
    // this.fetchProfilePhoto();

    this.establishNewWebsocketConnection(
      resource.userDto.userId,
      resource.userDto.availabilityStatus,
    );
    this.setContextCurrentUser(resource.userDto);

    if (successCallbackFunction) {
      successCallbackFunction(resource);
    }
  }
}
